export const BRANDS_EDIT_BRAND_OPEN_MODAL = "BRANDS_EDIT_BRAND_OPEN_MODAL";
export const BRANDS_EDIT_BRAND_CLOSE_MODAL = "BRANDS_EDIT_BRAND_CLOSE_MODAL";
export const BRANDS_EDIT_BRAND_REQUEST = "BRANDS_EDIT_BRAND_REQUEST";
export const BRANDS_EDIT_BRAND_RESULT = "BRANDS_EDIT_BRAND_RESULT";

export const BRANDS_EDIT_BRAND_GET_BRAND_REQUEST = "BRANDS_EDIT_BRAND_GET_BRAND_REQUEST";
export const BRANDS_EDIT_BRAND_GET_BRAND_RESULT = "BRANDS_EDIT_BRAND_GET_BRAND_RESULT";

export const BRANDS_EDIT_NEW_BRAND_REQUEST = "BRANDS_EDIT_NEW_BRAND_REQUEST";
export const BRANDS_EDIT_NEW_BRAND_RESULT = "BRANDS_EDIT_NEW_BRAND_RESULT";


